import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { dashboardService } from '../../services/api';

const LatestRegisteredOne = () => {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadOrganizations();
    }, []);

    const loadOrganizations = async () => {
        try {
            setLoading(true);
            const response = await dashboardService.getRecentOrganizations();
            if (response.success && response.data) {
                setOrganizations(response.data);
            }
        } catch (error) {
            console.error('Error loading organizations:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return 'bg-success-focus text-success-main border br-success';
            case 'trial':
                return 'bg-info-focus text-info-main border br-info';
            default:
                return 'bg-gray-focus text-gray-main border br-gray';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'active':
                return 'Aktif';
            case 'trial':
                return 'Deneme';
            default:
                return 'Pasif';
        }
    };

    return (
        <div className="col-xxl-9 col-xl-12">
            <div className="card h-100">
                <div className="card-body p-24">
                    <div className="d-flex flex-wrap align-items-center gap-1 justify-content-between mb-16">
                        <h6 className="text-lg mb-0">Son Organizasyonlar</h6>
                        <Link to="/organizations" className="text-primary-600 fw-semibold text-sm">
                            Tümünü Gör →
                        </Link>
                    </div>
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center py-40">
                            <p className="text-secondary-light">Yükleniyor...</p>
                        </div>
                    ) : organizations.length > 0 ? (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="text-sm fw-semibold text-primary-light">Organizasyon</th>
                                        <th className="text-sm fw-semibold text-primary-light">Sahip</th>
                                        <th className="text-sm fw-semibold text-primary-light">Durum</th>
                                        <th className="text-sm fw-semibold text-primary-light">Plan</th>
                                        <th className="text-sm fw-semibold text-primary-light">Tarih</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {organizations.map((org) => (
                                        <tr key={org.id}>
                                            <td>
                                                <div>
                                                    <p className="text-sm fw-semibold text-primary-light mb-1">{org.name}</p>
                                                    {org.title && <p className="text-xs text-secondary-light mb-0">{org.title}</p>}
                                                </div>
                                            </td>
                                            <td>
                                                <p className="text-sm text-primary-light mb-0">{org.owner_name || '-'}</p>
                                            </td>
                                            <td>
                                                <span className={`text-xs fw-semibold rounded-pill px-8 py-4 line-height-1 ${getStatusBadge(org.subscription_status)}`}>
                                                    {getStatusText(org.subscription_status)}
                                                </span>
                                            </td>
                                            <td>
                                                <p className="text-sm text-primary-light mb-0">{org.plan_name || '-'}</p>
                                            </td>
                                            <td>
                                                <p className="text-sm text-secondary-light mb-0">
                                                    {new Date(org.created_at).toLocaleDateString('tr-TR')}
                                                </p>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center py-40">
                            <p className="text-secondary-light">Organizasyon bulunamadı</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default LatestRegisteredOne
